import React from "react"

export interface DisplayDrawerContextType {
    (content: React.ReactNode): void
}

export const DisplayDrawerContext = React.createContext<DisplayDrawerContextType>(() => {});